// EmailJS Service Configuration
// EmailJS allows sending emails directly from the frontend without a backend

import emailjs from '@emailjs/browser';
import { emailjsConfig } from '../config/emailjs';

/**
 * Send booking email using EmailJS
 * @param {Object} bookingData - The booking data to send
 * @returns {Promise} - Promise that resolves when email is sent
 */
export const sendBookingEmail = async (bookingData) => {
  const { publicKey, serviceId, templateId, recipientEmail } = emailjsConfig;

  if (!publicKey || !serviceId || !templateId || !recipientEmail) {
    throw new Error(
      'EmailJS is not configured. Set REACT_APP_EMAILJS_* variables in .env and restart the dev server.'
    );
  }

  try {
    const templateParams = {
      to_email: recipientEmail,
      from_name: bookingData.name,
      from_email: bookingData.email,
      mobile: bookingData.mobile,
      location: bookingData.location,
      vehicle_no: bookingData.vehicleNo,
      vehicle_model: bookingData.vehicleModel,
      vehicle_kms: bookingData.kms,
      message: `New booking request received!\n\nName: ${bookingData.name}\nMobile: ${bookingData.mobile}\nEmail: ${bookingData.email}\nLocation: ${bookingData.location}\nVehicle No: ${bookingData.vehicleNo}\nVehicle Model: ${bookingData.vehicleModel}\nKM's: ${bookingData.kms}\nDate: ${bookingData.createdAt}`,
      subject: 'New Booking Request - Tamil Cars',
      customer_name: bookingData.name,
      customer_mobile: bookingData.mobile,
      customer_email: bookingData.email,
      customer_location: bookingData.location,
      customer_vehicle_no: bookingData.vehicleNo,
      customer_vehicle_model: bookingData.vehicleModel,
      customer_kms: bookingData.kms,
      booking_date: bookingData.createdAt
    };

    const response = await emailjs.send(serviceId, templateId, templateParams, {
      publicKey,
    });

    console.log('Email sent successfully!', response.status, response.text);
    return { success: true, response };
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};
